import {Auth} from "../firebase/auth";
import {IUsuario} from "services-comun-ed/modules/services/usuarios/interface";

export class UsuarioEquiposController {

    /* INSTANCE */
    public static instance: UsuarioEquiposController;
    private readonly escudos: HTMLCollectionOf<HTMLElement>;
    public preferences: string[];
    private readonly commonTags: string[];
    private readonly save: HTMLButtonElement;

    /* STATIC */
    public static async build(): Promise<void> {
        UsuarioEquiposController.instance = new this();
    }

    private constructor() {
        this.save = document.querySelector('#save-preferences') as HTMLButtonElement;
        if (this.save) this.save.addEventListener("click", this.savePreferences.bind(this));
        this.escudos = document.getElementsByClassName("escudo") as HTMLCollectionOf<HTMLElement>;
        const escudo_seleccionado = document.querySelector(".escudo-seleccionado") as HTMLElement;
        this.preferences = [];
        this.commonTags = ["futbol"];
        if (escudo_seleccionado) {
            const tags = JSON.parse(escudo_seleccionado.getAttribute("data-tags") as string);
            for (const tag of tags) if (!this.commonTags.includes(tag)) this.preferences.push(tag);
        }
        if (this.escudos) for (const escudo of Array.from(this.escudos)) escudo.addEventListener("click", this.clickEscudo.bind(this));
    }

    private async clickEscudo(event: Event): Promise<void> {
        const escudo = event.currentTarget as HTMLElement;
        const tags = JSON.parse(escudo.getAttribute("data-tags") as string);
        if (tags) {
            for (const tag of tags) {
                if (!this.preferences.includes(tag) && !this.commonTags.includes(tag)) {
                    if (this.preferences.length > 0) {
                        this.preferences = [];
                        document.querySelector(".escudo-seleccionado")?.classList.remove("escudo-seleccionado");
                    }
                    this.preferences.push(tag);
                    escudo.classList.add("escudo-seleccionado");
                }
            }
        }
    }

    private async savePreferences(): Promise<void> {
        const userEd = Auth.get()?.userEd as IUsuario;
        userEd.configuracion!.registro_inicial!.equipos_favoritos!.favoritos!.registro = this.preferences[0];
        const instance = Auth.get();
        await instance?.update(userEd);
        instance?.resetCookieFav();
        instance?.setCookieFav(this.preferences[0]);
    }

}
